import { HStack } from "@/components/ui/hstack";
import { Pressable } from "@/components/ui/pressable";
import { Center } from "@/components/ui/center";
import React from 'react';
import { useSelector } from "react-redux";
import ImageSynced from '../../components/media/ImageSynced';
import * as MediaSelector from "../../components/media/MediaSelector";
import { IconM } from "./IconsV2";

export default function AvatarEdit({ uri, sync, selected, isEdit }) {
    const imgLoad = useSelector((state) => state.images.load)
    const user = useSelector((state) => state.user)
    const imageCrop = useSelector((state) => state.settings.imageCrop)

    const selectAvatar = () => {
        if (isEdit) {
            MediaSelector.pickImage('Load Avatar', imageCrop, avatarSelected)
        }
    }

    const avatarSelected = async (image) => {
        if (image) {
            const newUri = await MediaSelector.storeImagesAsync([image.uri])
            if (newUri) {
                selected(newUri[0])
            }    
        }
    }

    const getRefresh = () => {
        return uri == user.id ? user.updated : imgLoad[uri]?.duration
    }

    return (
        <HStack className="self-center">
            <Pressable onPress={selectAvatar}>
                <ImageSynced key={uri + '_' + getRefresh()} uri={uri} refresh={+ getRefresh()} isAvatar={true} sync={sync} size='xl' className='self-center border border-primary-900 bg-secondary-50' />
                {isEdit && <Center className="absolute rounded-full border border-secondary-50 right-0 bottom-0 w-8 h-8 bg-primary-900">
                        <IconM className='text-lg text-secondary-50' name='edit' />
                    </Center>}
            </Pressable>
        </HStack>
    );
}
